module.exports = __webpack_public_path__ + "img/map_for_franchise_rus.e0810064.png";